export default __webpack_public_path__ + "static/media/without-content.117e5880.svg";